// Import language list
import btn_en_US from './en-US/btn.json';
import btn_es_CO from './es-CO/btn.json';
import btn_id_ID from './id-ID/btn.json';
import btn_ja_JP from './ja-JP/btn.json';
import btn_ko_KR from './ko-KR/btn.json';
import btn_ms_MY from './ms-MY/btn.json';
import btn_th_TH from './th-TH/btn.json';
import btn_vi_VN from './vi-VN/btn.json';
import btn_zh_CHS from './zh-CHS/btn.json';
import btn_zh_CHT from './zh-CHT/btn.json';

import create_bulk_order_en_US from './en-US/create_bulk_order.json';
import create_bulk_order_es_CO from './es-CO/create_bulk_order.json';
import create_bulk_order_id_ID from './id-ID/create_bulk_order.json';
import create_bulk_order_ja_JP from './ja-JP/create_bulk_order.json';
import create_bulk_order_ko_KR from './ko-KR/create_bulk_order.json';
import create_bulk_order_ms_MY from './ms-MY/create_bulk_order.json';
import create_bulk_order_th_TH from './th-TH/create_bulk_order.json';
import create_bulk_order_vi_VN from './vi-VN/create_bulk_order.json';
import create_bulk_order_zh_CHS from './zh-CHS/create_bulk_order.json';
import create_bulk_order_zh_CHT from './zh-CHT/create_bulk_order.json';

import create_single_order_en_US from './en-US/create_single_order.json';
import create_single_order_es_CO from './es-CO/create_single_order.json';
import create_single_order_id_ID from './id-ID/create_single_order.json';
import create_single_order_ja_JP from './ja-JP/create_single_order.json';
import create_single_order_ko_KR from './ko-KR/create_single_order.json';
import create_single_order_ms_MY from './ms-MY/create_single_order.json';
import create_single_order_th_TH from './th-TH/create_single_order.json';
import create_single_order_vi_VN from './vi-VN/create_single_order.json';
import create_single_order_zh_CHS from './zh-CHS/create_single_order.json';
import create_single_order_zh_CHT from './zh-CHT/create_single_order.json';

import date_picker_en_US from './en-US/date_picker.json';
import date_picker_es_CO from './es-CO/date_picker.json';
import date_picker_id_ID from './id-ID/date_picker.json';
import date_picker_ja_JP from './ja-JP/date_picker.json';
import date_picker_ko_KR from './ko-KR/date_picker.json';
import date_picker_ms_MY from './ms-MY/date_picker.json';
import date_picker_th_TH from './th-TH/date_picker.json';
import date_picker_vi_VN from './vi-VN/date_picker.json';
import date_picker_zh_CHS from './zh-CHS/date_picker.json';
import date_picker_zh_CHT from './zh-CHT/date_picker.json';

import detail_en_US from './en-US/detail.json';
import detail_es_CO from './es-CO/detail.json';
import detail_id_ID from './id-ID/detail.json';
import detail_ja_JP from './ja-JP/detail.json';
import detail_ko_KR from './ko-KR/detail.json';
import detail_ms_MY from './ms-MY/detail.json';
import detail_th_TH from './th-TH/detail.json';
import detail_vi_VN from './vi-VN/detail.json';
import detail_zh_CHS from './zh-CHS/detail.json';
import detail_zh_CHT from './zh-CHT/detail.json';

import history_en_US from './en-US/history.json';
import history_es_CO from './es-CO/history.json';
import history_id_ID from './id-ID/history.json';
import history_ja_JP from './ja-JP/history.json';
import history_ko_KR from './ko-KR/history.json';
import history_ms_MY from './ms-MY/history.json';
import history_th_TH from './th-TH/history.json';
import history_vi_VN from './vi-VN/history.json';
import history_zh_CHS from './zh-CHS/history.json';
import history_zh_CHT from './zh-CHT/history.json';

import import_list_en_US from './en-US/import_list.json';
import import_list_es_CO from './es-CO/import_list.json';
import import_list_id_ID from './id-ID/import_list.json';
import import_list_ja_JP from './ja-JP/import_list.json';
import import_list_ko_KR from './ko-KR/import_list.json';
import import_list_ms_MY from './ms-MY/import_list.json';
import import_list_th_TH from './th-TH/import_list.json';
import import_list_vi_VN from './vi-VN/import_list.json';
import import_list_zh_CHS from './zh-CHS/import_list.json';
import import_list_zh_CHT from './zh-CHT/import_list.json';

import popup_en_US from './en-US/popup.json';
import popup_es_CO from './es-CO/popup.json';
import popup_id_ID from './id-ID/popup.json';
import popup_ja_JP from './ja-JP/popup.json';
import popup_ko_KR from './ko-KR/popup.json';
import popup_ms_MY from './ms-MY/popup.json';
import popup_th_TH from './th-TH/popup.json';
import popup_vi_VN from './vi-VN/popup.json';
import popup_zh_CHS from './zh-CHS/popup.json';
import popup_zh_CHT from './zh-CHT/popup.json';

import track_en_US from './en-US/track.json';
import track_es_CO from './es-CO/track.json';
import track_id_ID from './id-ID/track.json';
import track_ja_JP from './ja-JP/track.json';
import track_ko_KR from './ko-KR/track.json';
import track_ms_MY from './ms-MY/track.json';
import track_th_TH from './th-TH/track.json';
import track_vi_VN from './vi-VN/track.json';
import track_zh_CHS from './zh-CHS/track.json';
import track_zh_CHT from './zh-CHT/track.json';

import user_profile_en_US from './en-US/user_profile.json';
import user_profile_es_CO from './es-CO/user_profile.json';
import user_profile_id_ID from './id-ID/user_profile.json';
import user_profile_ja_JP from './ja-JP/user_profile.json';
import user_profile_ko_KR from './ko-KR/user_profile.json';
import user_profile_ms_MY from './ms-MY/user_profile.json';
import user_profile_th_TH from './th-TH/user_profile.json';
import user_profile_vi_VN from './vi-VN/user_profile.json';
import user_profile_zh_CHS from './zh-CHS/user_profile.json';
import user_profile_zh_CHT from './zh-CHT/user_profile.json';

import validation_en_US from './en-US/validation.json';
import validation_es_CO from './es-CO/validation.json';
import validation_id_ID from './id-ID/validation.json';
import validation_ja_JP from './ja-JP/validation.json';
import validation_ko_KR from './ko-KR/validation.json';
import validation_ms_MY from './ms-MY/validation.json';
import validation_th_TH from './th-TH/validation.json';
import validation_vi_VN from './vi-VN/validation.json';
import validation_zh_CHS from './zh-CHS/validation.json';
import validation_zh_CHT from './zh-CHT/validation.json';

const QchoiceLanguage = {
  'en-US': {
    ...btn_en_US,
    ...create_bulk_order_en_US,
    ...create_single_order_en_US,
    ...date_picker_en_US,
    ...import_list_en_US,
    ...detail_en_US,
    ...history_en_US,
    ...popup_en_US,
    ...track_en_US,
    ...user_profile_en_US,
    ...validation_en_US,
  },

  'es-CO': {
    ...btn_es_CO,
    ...create_bulk_order_es_CO,
    ...create_single_order_es_CO,
    ...date_picker_es_CO,
    ...import_list_es_CO,
    ...detail_es_CO,
    ...history_es_CO,
    ...popup_es_CO,
    ...track_es_CO,
    ...user_profile_es_CO,
    ...validation_es_CO,
  },

  'id-ID': {
    ...btn_id_ID,
    ...create_bulk_order_id_ID,
    ...create_single_order_id_ID,
    ...date_picker_id_ID,
    ...import_list_id_ID,
    ...detail_id_ID,
    ...history_id_ID,
    ...popup_id_ID,
    ...track_id_ID,
    ...user_profile_id_ID,
    ...validation_id_ID,
  },

  'ja-JP': {
    ...btn_ja_JP,
    ...create_bulk_order_ja_JP,
    ...create_single_order_ja_JP,
    ...date_picker_ja_JP,
    ...import_list_ja_JP,
    ...detail_ja_JP,
    ...history_ja_JP,
    ...popup_ja_JP,
    ...track_ja_JP,
    ...user_profile_ja_JP,
    ...validation_ja_JP,
  },

  'ko-KR': {
    ...btn_ko_KR,
    ...create_bulk_order_ko_KR,
    ...create_single_order_ko_KR,
    ...date_picker_ko_KR,
    ...import_list_ko_KR,
    ...detail_ko_KR,
    ...history_ko_KR,
    ...popup_ko_KR,
    ...track_ko_KR,
    ...user_profile_ko_KR,
    ...validation_ko_KR,
  },

  'ms-MY': {
    ...btn_ms_MY,
    ...create_bulk_order_ms_MY,
    ...create_single_order_ms_MY,
    ...date_picker_ms_MY,
    ...import_list_ms_MY,
    ...detail_ms_MY,
    ...history_ms_MY,
    ...popup_ms_MY,
    ...track_ms_MY,
    ...user_profile_ms_MY,
    ...validation_ms_MY,
  },

  'th-TH': {
    ...btn_th_TH,
    ...create_bulk_order_th_TH,
    ...create_single_order_th_TH,
    ...date_picker_th_TH,
    ...import_list_th_TH,
    ...detail_th_TH,
    ...history_th_TH,
    ...popup_th_TH,
    ...track_th_TH,
    ...user_profile_th_TH,
    ...validation_th_TH,
  },

  'vi-VN': {
    ...btn_vi_VN,
    ...create_bulk_order_vi_VN,
    ...create_single_order_vi_VN,
    ...date_picker_vi_VN,
    ...import_list_vi_VN,
    ...detail_vi_VN,
    ...history_vi_VN,
    ...popup_vi_VN,
    ...track_vi_VN,
    ...user_profile_vi_VN,
    ...validation_vi_VN,
  },

  'zh-CHS': {
    ...btn_zh_CHS,
    ...create_bulk_order_zh_CHS,
    ...create_single_order_zh_CHS,
    ...date_picker_zh_CHS,
    ...import_list_zh_CHS,
    ...detail_zh_CHS,
    ...history_zh_CHS,
    ...popup_zh_CHS,
    ...track_zh_CHS,
    ...user_profile_zh_CHS,
    ...validation_zh_CHS,
  },

  'zh-CHT': {
    ...btn_zh_CHT,
    ...create_bulk_order_zh_CHT,
    ...create_single_order_zh_CHT,
    ...date_picker_zh_CHT,
    ...import_list_zh_CHT,
    ...detail_zh_CHT,
    ...history_zh_CHT,
    ...popup_zh_CHT,
    ...track_zh_CHT,
    ...user_profile_zh_CHT,
    ...validation_zh_CHT,
  }
};

export default QchoiceLanguage;
